import axios from "axios";
import { extApi,tmsApi } from "../api";

export const getExternalUserList = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(extApi + `v2/entities/thirdparty/user/list/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createExternalUserList = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(extApi + `v2/entities/thirdparty/user/create`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const getExternalUserById = (id) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(extApi + `v2/entities/thirdparty/user/detail/${id}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const updateExternalUser = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .put(extApi + `v2/entities/thirdparty/user/update`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const ChangeExternalUserPassword = async (body) => {
    const config = {
      headers: {
        token: `${localStorage.getItem('token')}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    try {
      return axios.post(extApi + "v2/thirdparty/users/auth/changepassword",body, config).then((resp) => {
        console.log(resp, "response");
        return resp;
      });
    } catch (error) {
      console.log("error", error);
      // return error;
     
    }
  };

  export const getExternalUserBySearch = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(extApi + `v2/entities/thirdparty/user/search/${obj.serviceCityId}/${obj.key}?page=${obj.page}&size=${obj.size}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
